import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentCollectionSidebarCustomFields } from "./ContentCollectionSidebarCustomFields";
import { ContentCollectionSidebarHeader } from "./ContentCollectionSidebarHeader";
import { ContentCollectionSidebarSeparator } from "./ContentCollectionSidebarSeparator";
export const ContentCollectionManageSidebar = (param)=>{
    let { renderCustomField, renderSubmitButton } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full shrink-0 md:h-full md:w-[372px] md:p-2",
        children: /*#__PURE__*/ _jsxs("aside", {
            className: "flex flex-col rounded-lg border-b border-grey-5 bg-grey-1 md:h-full md:overflow-y-auto md:rounded-8 md:border",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex grow flex-col gap-6 px-4 py-6 pb-24",
                    children: [
                        /*#__PURE__*/ _jsx(ContentCollectionSidebarHeader, {
                            className: "hidden md:flex"
                        }),
                        /*#__PURE__*/ _jsx(ContentCollectionSidebarSeparator, {
                            className: "hidden md:block"
                        }),
                        /*#__PURE__*/ _jsx(ContentCollectionSidebarCustomFields, {
                            renderCustomField: renderCustomField
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "sticky bottom-0 hidden items-center bg-grey-1 p-4 md:flex",
                    children: renderSubmitButton()
                })
            ]
        })
    });
};
